module.exports = __webpack_public_path__ + "img/icon_vedio_logo_n.7552f312.png";